import Vue from 'vue';
import { VTooltip as directive } from 'v-tooltip';

// TODO: fixme
// VTooltip.options.defaultTrigger = window.innerWidth > 768 ? 'hover focus click' : 'click';

export default {
	register(instance = Vue) {
		instance.directive('tooltip', directive);
	},
};
